import { styled } from '@teko/ds-desktop';
import React from 'react';
import { t } from '../../i18n.es.js';
import { formatCurrency } from '../../helpers/number.es.js';

const background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA5NiA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iNDAiIHJ4PSI0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIiAvPgogIDxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9Ijk2IiBoZWlnaHQ9IjQwIj4KICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI0MCIgcng9IjQiIGZpbGw9IndoaXRlIiAvPgogIDwvbWFzaz4KICA8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CiAgICA8cGF0aCBvcGFjaXR5PSIwLjMiCiAgICAgIGQ9Ik03NC4yNDQ2IC05LjAyODY5TDY1Ljg3NjcgOC45MTYyMUw3MC43NzA4IDExLjE5ODNMNjMuOTI0NCAyNS44ODA1TDg0LjQ3MjQgMTEuNjI5M0w3Ny45NDcgOC41ODY0Mkw5MC41NTgxIC0xLjQyMTU2TDc0LjI0NDYgLTkuMDI4NjlaIgogICAgICBmaWxsPSIjMUIxRDI5IiAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjM1LjcyMDkiIHkxPSIxLjY2NTQ0ZS0wNiIgeDI9IjU3Ljg4ODYiIHkyPSI0MC4wODczIgogICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNBQTIwRkYiIC8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzQxM0VGRiIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgo8L3N2Zz4=";
const SIZE = {
  s: {
    titleFont: 8,
    discountFont: 12,
    discountLineHeight: 16
  },
  m: {
    titleFont: 10,
    discountFont: 13,
    discountLineHeight: 18
  }
};
const MobileSavingBadge = ({
  savingAmount
}) => {
  const formattedSavingAmount = formatCurrency(savingAmount);
  return /* @__PURE__ */ React.createElement(Wrapper, {
    background
  }, /* @__PURE__ */ React.createElement(Title, {
    size: "s"
  }, t("TI\u1EBET KI\u1EC6M")), /* @__PURE__ */ React.createElement(DiscountAmount, {
    size: "s"
  }, formattedSavingAmount));
};
const Wrapper = styled.div(({ background: background2, theme }) => `
  height: 36px;
  line-height: 12px;
  background: url("${background2}");
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${theme.spacing.s4} ${theme.spacing.s8};
  border-radius: ${theme.borderRadius.s};
  background-size: cover;
`);
const Title = styled.div(({ size }) => `
    font-size: ${SIZE[size].titleFont}px;
    font-weight: 700;
    color: #ffd591;
`);
const DiscountAmount = styled.div(({ size, theme }) => `
    font-size: ${SIZE[size].discountFont}px;
    line-height: ${SIZE[size].discountLineHeight}px;
    font-weight: 700;
    color: ${theme.colors.white};
`);

export { MobileSavingBadge };
